import { Code01Icon, Send03Icon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

export function FilterBarRawInput(props: {
  onSuccess: (query: string) => boolean;
}) {
  const [value, setValue] = useState('');

  return (
    <form
      className="grid grid-cols-[auto,1fr,auto] items-center overflow-hidden rounded-md border border-secondary"
      onSubmit={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (value) {
          if (props.onSuccess(value)) {
            setValue('');
          }
        }
      }}
    >
      <div className="pl-3">
        <Code01Icon className="size-4" />
      </div>
      <input
        placeholder='eg. eq(status, "error")'
        className=" bg-background px-3 py-2 focus-within:border-brand focus:outline-none"
        size={6}
        name="value"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />

      <button
        type="submit"
        disabled={!value}
        className="p-2.5 text-ls-black transition-opacity disabled:opacity-70"
      >
        <Send03Icon className="size-5" />
      </button>
    </form>
  );
}
